/* tslint:disable:no-access-missing-member */
import { AfterViewInit, Component, ElementRef, ViewChild,Input } from '@angular/core';
import Highcharts from 'highcharts';
import * as api from '../../../../api';
import { FacilitiesService } from '../../../../core/facilities/facilities.service';
import { ChartOptionsFactory } from '../../../chart-options-factory';
import { AbstractSummedAggregateSummaryChartsComponent } from '../../abstract-summed-aggregate-charts.component';
import { LoadingError } from "../../../../core/error-catching.service";
import { takeUntil, catchError } from 'rxjs/operators';
import { ApiRequestDto } from '../../../../api';


/**
 * Total Pharmacy Cost Summary Widget - shows pair of charts.
 */
@Component({
    selector: 'my-total-cost-summary-charts',
    template: `
        <div class="row" routerLink="{{link}}">
            <div class="col-12 report-wrapper">
                <div class="col-4">
                    <div #totalChart></div>
                </div>
                <my-pharmacy-cost-by-type-chart
                        [hasTitle]="hasTitle"
                        [dateRange]="dateRange"
                ></my-pharmacy-cost-by-type-chart>
            </div>
        </div>
    `,
    styleUrls: ['../../reports-summaries.component.scss'],
    inputs: AbstractSummedAggregateSummaryChartsComponent.INPUTS

})
export class TotalCostSummaryChartsComponent extends AbstractSummedAggregateSummaryChartsComponent implements AfterViewInit {

    ////// Pie Chart of Total Cost
    @ViewChild('totalChart', {static: false}) totalChartDivRef: ElementRef;
    private totalChart: Highcharts.Chart;

    /** Construct */
    constructor(private financialApi: api.FinancialService,
                facilitiesSvc: FacilitiesService,) {
        super(facilitiesSvc);
    }

    @Input() hasTitle?: boolean = true;

    @Input() link: string

    totalChartTitle: string = 'Total Pharmacy Cost';

    /**
     * Setup the charts.
     * @override
     */
    buildAllCharts(): void {
        let totalChartOptions = ChartOptionsFactory.buildPieType(
            this.hasTitle ? this.totalChartTitle : '', (value) => this.formatCurrency0(value));
        this.totalChart = super.createChart(this.totalChartDivRef, totalChartOptions);
    }


    /**
     * Fetch all data and update display
     * @override
     */
    fetchAndPopulate(): void {
        const requestParams: ApiRequestDto = {
            StartDate: this.dateRange.startJsDateUTC,
            EndDate: this.dateRange.endJsDateUTC,
            OrgList: this.facilitiesSvc.selectedAsOrgList
        };
        this.financialApi.financialGetPharmacyChargesByPayType(requestParams)
            .pipe(takeUntil(this.stop$),
                catchError((error) => {
                    // create compound error because of weird if statement below
                    throw new LoadingError(this.totalChartTitle);
                }))
            .subscribe((data: api.SummedAggregateData) => {
                this.populateSummedPie(this.totalChart, data);
            });
    }
}

